<app-hero [brands]="brands"></app-hero>

<app-magic-bit-section></app-magic-bit-section>

<div id="dp-programs" class="mt-5">
  <app-programs></app-programs>
</div>

<br />
<br />
<br />

<app-stats></app-stats>

<br />
<br />

<app-dp-apps></app-dp-apps>

<section class="stories" id="success-stories">
  <div class="container w-75 mx-auto">

    <!-- <div class="title"> </div> -->
    <div class="title text-center mb-5" i18n="home stories: title">Stories that <span class="position-relative"
        style="font-family: 'Poppins Bold';">Inspire<img class="position-absolute" style="left: 0;
    bottom: -20px;
    width: 175px;" src="./assets/lines/3.png" alt=""></span></div>
    <div id="carouselStories" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
      <div class="carousel-inner">

        <div *ngFor="let story of displayStories; let i = index" [ngClass]="{'active': i === 0}" class="carousel-item">
          <div class="story-box d-flex gap-5 align-items-md-end align-items-center justify-content-between">
            <div class="story">{{story.description}}</div>
            <div class="by">
              <div *ngIf="story.image; else imgPlaceholder" class="avatar"
                [style.background-image]="'url(' + story._image + ')'"></div>

              <ng-template #imgPlaceholder>
                <div class="avatar" [style.background-image]="'url(/assets/images/trustees/pic-placeholder.jpg)'"></div>
              </ng-template>

              <div class="name">{{story.title}}</div>
              <div class="grade">{{story.subtitle}}</div>
            </div>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev story-nav-prev" type="button" data-bs-target="#carouselStories"
        data-bs-slide="prev">
        <span class="story-nav carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next story-nav-next" type="button" data-bs-target="#carouselStories"
        data-bs-slide="next">
        <span class="story-nav carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</section>

<app-partners></app-partners>

<div class="fixed-learn-more" [routerLink]="['/what-we-offer']" i18n="home mobile bottom: learn more">
  Learn More
</div>